import React from 'react';

const BaselineComparisonEmptyState: React.FC = () => {
  return (
    <div className="p-4 text-center text-gray-500 dark:text-gray-400">
      <p>No comparison data available</p>
      <p className="text-sm mt-1">Select multiple models to compare against baseline</p>
    </div>
  );
};

export default BaselineComparisonEmptyState;
